import * as types from '../constants/actionTypes';
import { wrapCall } from '../utils/serviceUtils';
import { api } from '../utils/services';

export const resetInsightsData = (fields) => {
  return {
    type: types.RESET_INSIGHTS_DATA,
    fields
  };
};

export const fetchAgeGroup = () => {
  return wrapCall(
    api.get(`/ageGroups`),
    types.FETCH_AGE_GROUP,
  );
}

export const fetchFocusArea = (section) => {
  return wrapCall(
    api.get(`/business/insightFocuses?section=${section}`),
    types.FETCH_FOCUS_AREA
  );
}

export const fetchInsightCharts = (section) => {
  return wrapCall(
    api.get(`/business/insightCharts?section=${section}`),
    types.FETCH_INSIGHT_CHARTS
  );
}

export const fethcInsightFilters = (section) => {
  return wrapCall(
    api.get(`/business/insightFilters?section=${section}`),
    types.FETCH_INSIGHT_FILTERS
  );
}

export const fetchInsightsSales = (a, filter) => {
  return wrapCall(
    api.get(`/business/me/analytics?&s=2&a=${a ? a : ''}${filter ? ('&' + filter) : ''}`),
    types.FETCH_INSIGHTS_SALES
  );
};

export const fetchInsightsCampaigns = (a, filter) => {
  return wrapCall(
    api.get(`/business/me/analytics?&s=1&a=${a ? a : ''}${filter ? ('&' + filter) : ''}`),
    types.FETCH_INSIGHTS_CAMPAIGNS
  );
};

export const fetchInsightsEmployees = (a, filter) => {
  return wrapCall(
    api.get(`/business/me/analytics?&s=3&a=${a ? a : ''}${filter ? ('&' + filter) : ''}`),
    types.FETCH_INSIGHTS_PRODUCTS
  );
};

export const fetchInsightsProducts = (a, filter) => {
  return wrapCall(
    api.get(`/business/me/analytics?&s=3&a=${a ? a : ''}${filter ? ('&' + filter) : ''}`),
    types.FETCH_INSIGHTS_PRODUCTS
  );
};

export const fetchInsightsProfile = (a, filter) => {
  return wrapCall(
    api.get(`/business/me/analytics?&s=4&a=${a ? a : ''}${filter ? ('&' + filter) : ''}`),
    types.FETCH_INSIGHTS_PROFILE
  );
};
